const data = {
    module_name: "bodegas",
    title: "Bodegas",
    key: 'bodegas',
    category_key: "",
    excel_key: "bodegas"
}

module.exports = data